import i18n from '../../../i18n';
import { LanguageObject } from '../v2/api/language/types';
import { HasDependencies } from '../v2/api/types';
import { Languages } from '../v2/constants';

export class LanguageStore implements HasDependencies {
  public languages: LanguageObject[] = [
    {
      id: Languages.JA,
      shortName: 'JA',
      longName: 'Japanese',
      translationKey: 'common:commonValues.japanese',
    },
    {
      id: Languages.EN,
      shortName: 'EN',
      longName: 'English',
      translationKey: 'common:commonValues.english',
    },
  ];

  public selectedLanguage: LanguageObject;
  public constructor(selectedLanguage: LanguageObject) {
    this.selectedLanguage = selectedLanguage;
  }

  public getDeps = () => [this.selectedLanguage.id];

  public findSelectedLanguage(id: string) {
    return this.languages.find((lng) => lng.id === id) || this.languages[0];
  }

  public setLanguageInLocalStorage = (id: string) => {
    this.selectedLanguage = this.findSelectedLanguage(id);
    void i18n.changeLanguage(this.selectedLanguage.id);
  };
}
